import { createWebHistory, createRouter } from 'vue-router';

import NewsFeed from '@/layouts/NewsFeed.vue';
import authRoutes from '@/router/auth/auth.js';
import ProfileFeed from '@/layouts/ProfileFeed.vue';

import store from '@/store/index.js';

const routes = [
    {
        path: '/', redirect: '/login', meta: { requiredAuth: false }
    },
    {
        path: '/profile/:id', component: ProfileFeed, name: 'profile', meta: { requiredAuth: true },
        children: [
            {
                path: '', component: () => import('@/components/ProfileTimeline.vue'), name: 'timeline', meta: { requiredAuth: true }
            },
            {
                path: 'friend', component: () => import('@/components/ProfileFriend.vue'), name: 'friend', meta: { requiredAuth: true }
            },
            {
                path: 'about', component: () => import('@/components/ProfileAbout.vue'), name: 'about', meta: { requiredAuth: true }
            },
            {
                path: 'photo', component: () => import('@/components/ProfilePhoto.vue'), name: 'photo', meta: { requiredAuth: true }
            },
        ]
    },
    {
        path: '/home', component: null, name: 'home', meta: { requiredAuth: true },
        children: [
            {
                path: '', component: NewsFeed, name: 'feed', meta: { requiredAuth: true }
            },
        ]
    },
    ...authRoutes
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

router.beforeEach(function (to, _, next) {
    if (to.meta.requiredAuth && !store.getters['auth/isAuthenticated']) {
        next('/login');
    } else if (!to.meta.requiredAuth && store.getters['auth/isAuthenticated']) {
        next('/home');
    } else {
        next();
    }
})

export default router;